// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"ResetForm__loginForm__9JUb7","alertsMb":"ResetForm__alertsMb__3mmp3","submitButton":"ResetForm__submitButton__1lCWz","paragraph":"ResetForm__paragraph__2G9NE","headline":"ResetForm__headline__NBE_g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResetForm/ResetForm.css
// module id = 1029
// module chunks = 0